import React, { useEffect, useState } from 'react';
import useIntersectionObserver from '../../../lib/hook/observer';

function AnimatedElement({ children, animationClass, delay = 0 }) {
  const [setRef, isVisible] = useIntersectionObserver({
    threshold: 0.1,
  });
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setShouldAnimate(true);
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [isVisible, delay]);

  return (
    <div
      ref={setRef}
      className={`animate__animated ${shouldAnimate ? animationClass : ""}`}
      style={{
        visibility: shouldAnimate ? "visible" : "hidden",
        animationDelay: `${delay}ms`,
      }}
    >
      {children}
    </div>
  );
}

export default AnimatedElement;
